import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import { healthRemove } from '../player.type';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Spark extends Modifier {
  static readonly baseTitle = 'Spark';
  static readonly baseText =
    'Take damage equal to half of stacks for each technique used, then halve. Halve at end of turn.';
  static readonly baseIcon = 'lightning';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Spark.baseTitle;
  text = Spark.baseText;
  icon = Spark.baseIcon;
  tags: Array<ModifierTags> = [...Spark.baseTags];
  priority = Spark.basePriority;

  endTurn() {
    this.halveStacks();
  }

  useTechnique() {
    var half = Math.ceil(this.stacks / 2);
    const damage: Damage = {
      value: half,
      target: this.owner,
      source: this.owner,
      dice: [],
    };

    healthRemove(damage);

    this.removeStacks(half);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Spark, Spark);
